export default {
      id: "clock-activated-yellow-usage",
      viewBox: "0 0 23 28",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#clock-activated-yellow-usage",
      toString: function () {
        return this.url;
      }
    }